import React from "react";
import tw, { styled, css } from "twin.macro";
import AnimateHeight from "react-animate-height";
import { useInView } from "react-intersection-observer";

const InputWrapper = styled.div(({ width = 1, sidebar, type, inview }) => [
  tw`flex flex-col`,
  !sidebar && tw`opacity-0 translate-y-[25px] duration-700 ease-in-out`,
  sidebar && tw`mb-8`,
  sidebar && type === "textarea" && tw`mt-12 mb-0`,
  inview && tw`translate-y-0 opacity-100`,
  css`
    grid-column: ${width === "full" ? "1 / -1" : `span ${width}`};
  `,
]);

const Label = styled.label(({ sidebar }) => [
  tw`font-bold text-white`,
  sidebar && tw`text-font`,
]);

const InputStyles = ({ valid, sidebar }) => [
  tw`bg-transparent border-b border-white border-opacity-40 p-2 transition-colors duration-500 ease-in-out [&:disabled]:(border-gray-600) focus:(border-opacity-100 outline-none border-primary)`,
  sidebar && tw`border-font border-b-2`,
  valid === false && tw`border-red-500 border-opacity-100`,
  valid === true && tw`border-primary border-opacity-100`,
];

const InputComp = styled.input(InputStyles);
const SelectComp = styled.select(InputStyles);

const TextArea = styled.textarea(({ sidebar }) => [
  InputStyles,
  tw`min-h-[8rem]`,
  sidebar && tw`min-h-[6rem]`,
]);

const Error = tw.p`font-bold text-red-500`;

const FormInput = ({
  sidebar,
  type,
  required,
  label,
  index,
  valid,
  errorMessage,
  onChange,
  inputRef,
  disabled,
  options,
  id,
  ...rest
}) => {
  let Input = InputComp; // Default to input
  switch (type) {
    case "textarea":
      Input = TextArea;
      break;
    case "select":
      Input = SelectComp;
      break;
  }

  const [ref, inView] = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  return (
    <InputWrapper
      {...rest}
      type={type}
      sidebar={sidebar}
      ref={ref}
      inview={inView}
    >
      <Label htmlFor={id} sidebar={sidebar}>
        {label}
        {required && " *"}
      </Label>
      <Input
        sidebar={sidebar}
        ref={inputRef}
        type={type}
        name={label}
        id={id}
        valid={valid}
        onChange={onChange}
        data-index={index}
        required={required}
        disabled={disabled}
      >
        {options &&
          options.map(({ value, text }, i) => (
            <option key={i} value={value ? value : text} selected={!!!value}>
              {text}
            </option>
          ))}
      </Input>
      <AnimateHeight duration={500} height={valid === false ? "auto" : 0}>
        <Error>{errorMessage}</Error>
      </AnimateHeight>
    </InputWrapper>
  );
};

export default FormInput;
